export function getAnalyticsRange(timeRange: string) {
  const end = new Date();
  const start = new Date(end);
  if (timeRange === "7d") start.setDate(end.getDate() - 7);
  else if (timeRange === "30d") start.setDate(end.getDate() - 30);
  else if (timeRange === "month") start.setMonth(end.getMonth() - 1);
  else if (timeRange === "year") start.setFullYear(end.getFullYear() - 1);
  else if (timeRange === "all") start.setTime(0);
  return { startDate: start.toISOString(), endDate: end.toISOString() };
}
